import React from 'react';
import { useWindowSize } from 'usehooks-ts';

export function GenericDecoration({
  bottomGraphicSrc,
  hideDecorationOnDesktop,
}) {
  const isMobile = useWindowSize().width <= 768;
  const showDecoration = !hideDecorationOnDesktop || isMobile;

  if (!showDecoration) {
    return null;
  }

  return (
    <div className="bottomgraphic">
      <img src={bottomGraphicSrc} />
    </div>
  );
}